// Tożsamość klubu tej instancji — JEDNO miejsce na id drużyny, nazwy i ligę.
// Backend ma swój odpowiednik w env (`OUR_TEAM_ID`, `ANCHOR_COMPETITION_ID`);
// tu stałe, bo fork jest jednoklubowy, a herb i podpisy są potrzebne przed
// pierwszym zapytaniem do API.

/** StatsBomb team_id Pogoni Grodzisk Mazowiecki. */
export const OUR_TEAM_ID = 35036
export const CLUB_NAME = 'Pogoń Grodzisk Mazowiecki'
export const CLUB_SHORT = 'Pogoń GM'

/** Liga bazowa: I liga (StatsBomb competition_id). */
export const LEAGUE_COMPETITION_ID = 1848
export const LEAGUE_NAME = 'I liga'

// Nazwa aplikacji = nazwa klubu (belka, tytuły kart, ekran logowania, maile).
export const APP_NAME = CLUB_NAME
